<nav #header class="fixed-top" style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerHeader" style="background-color: #091d42
    ">
        <div class="contact">
            <a href="tel:+593991283079" role="button" style="display: flex; align-items: center;">
                <i class="fa fa-whatsapp" style="font-size: 1.5rem;color: green;"></i>
                <span>+593 99 128 3079</span>
            </a>
            <span>|</span>
            <a href="tel:+18669870876" class="toll" role="button" style="display: flex; align-items: center;">
                <i class="fa fa-phone"></i>
                <span>Toll free: +1 866 987 0876</span>
            </a>
            <a href="mailto:info&#64;rebeccaadventuretravel.com" class="mail" role="button"
                style="display: flex; align-items: center;">
                <i class="fa fa-phone"></i>
                <span>info&#64;rebeccaadventuretravel.com</span>
            </a>
        </div>
        <div></div>
    </div>
    <div class="menuButton">
        <a href="{{this.companyParamsService.getWebSite()}}" class="navbar-brand" style="justify-content: flex-start;">
            <img src="../assets/images/logos-header/rat.svg" height="75" alt="logo" class="brand-logo">
        </a>
        <a (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <div class="containerMenu navbar-collapse collapse" [ngClass]="showMenu ? 'showMenu':''">
        <div class="logo-desktop">
            <a href="{{this.companyParamsService.getWebSite()}}" class="navbar-brand"
                style="display: flex; justify-content: flex-start; align-items: center;" target="_blank">
                <img id="logoMenu" src="../assets/images/logos-header/rat.svg" height="75" alt="logo" class="logoMenu">
                <span style="display: inline-block;">
                    <div style="color: #091d42;font-size: 1.3vw;font-weight: bold;">Rebecca Adventure Travel</div>
                    <div class="small">Travel with purpose, powered by impact</div>
                </span>
            </a>
        </div>
        <ul class="navbar-nav">
            <li class="nav-item menuItem bordernone rightButtonMobile">
                <a class="last" href="https://rebeccaadventuretravel.com/build-your-own-trip/">
                    <strong>Build your trip</strong>
                </a>
            </li>
            <li class="nav-item menuItem">
                <a href="https://rebeccaadventuretravel.com/galapagos/" target="_blank">Galapagos</a>
            </li>
            <li class="nav-item menuItem">
                <a href="https://rebeccaadventuretravel.com/destinations/" target="_blank">Destinations</a>
            </li>
            <li class="nav-item menuItem">
                <a href="https://rebeccaadventuretravel.com/travel-styles/south-america-luxury-travel/" target="_blank">Travel Styles & Activities</a>
            </li>
            <li class="nav-item menuItem">
                <a href="https://rebeccaadventuretravel.com/blog/galapagos/best-time-to-travel-to-galapagos/" target="_blank">Travel Guides</a>
            </li>
            <li class="nav-item menuItem">
                <a href="https://rebeccaadventuretravel.com/about-rebecca-adventure-travel/" target="_blank">About
                    us</a>
            </li>
            <li class="nav-item menuItem">
                <a class="last" href="https://rebeccaadventuretravel.com/contact/" target="_blank">Contact</a>
            </li>
            <li class="nav-item menuItem bordernone" *ngIf="companyParamsService.getFiltersInterest()">
                <app-heart-header></app-heart-header>
            </li>
            <li class="nav-item menuItem bordernone">
                <a href="https://rebeccaadventuretravel.com/becoming-b-corp-certified/" class="last" target="_blank"><img
                        class="bcorp-logo" height="60px" width="auto"
                        src="https://rebeccaadventuretravel.com/wp-content/uploads/2024/02/certified-b-corporation.png"
                        alt="b-certified corporation logo"></a>
            </li>
        </ul>

    </div>
</nav>